<template>
  <div>
    <div class="max-w-7xl mx-auto">
      <div class="bg-white rounded-lg shadow-sm">
        <div class="p-4 border-b">
          <div class="text-neutral-500 text-xl font-medium font-['Poppins']">Perfil</div>
        </div>
              
        <div class="p-4">
          <form @submit.prevent="submitForm">
            <!-- Grid responsive para los campos del formulario -->
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <!-- Email -->
              <div class="space-y-2">
                <label  class="text-standard">Email</label>
                <input 
                  v-model="form.email" 
                  type="email" 
                  class="w-full text-neutral-500 text-sm font-light font-['Poppins'] leading-normal px-4 py-2 rounded-md border border-gray-300"
                  placeholder="Ingrese su email"
                  required
                >
              </div>

              <!-- Nombre -->
              <div class="space-y-2">
                <label class="text-standard block">Nombre</label>
                <input 
                  v-model="form.name" 
                  type="text" 
                  class="w-full text-neutral-500 text-sm font-light font-['Poppins'] leading-normal px-4 py-2 rounded-md border border-gray-300"
                  placeholder="Primer nombre"
                  required
                >
              </div>

              <!-- Apellido Paterno -->
              <div class="space-y-2">
                <label class="text-standard block">Apellido Paterno</label>
                <input 
                  v-model="form.last_name" 
                  type="text" 
                  class="w-full text-neutral-500 text-sm font-light font-['Poppins'] leading-normal px-4 py-2 rounded-md border border-gray-300"
                  placeholder="Primer apellido"
                  required
                >
              </div>

              <!-- Apellido Materno -->
              <div class="space-y-2">
                <label class="text-standard block">Apellido Materno</label>
                <input 
                  v-model="form.last_second_name" 
                  type="text" 
                  class="w-full text-neutral-500 text-sm font-light font-['Poppins'] leading-normal px-4 py-2 rounded-md border border-gray-300"
                  placeholder="Segundo apellido"
                  required
                >
              </div>

              <!-- Contraseña -->
              <div class="space-y-2">
                <label class="text-standard block">Contraseña</label>
                <input 
                  v-model="form.password" 
                  type="password" 
                  class="w-full text-neutral-500 text-sm font-light font-['Poppins'] leading-normal px-4 py-2 rounded-md border border-gray-300"
                  placeholder="Mínimo 8 caracteres"
                  pattern=".{8,}"
                  required
                >
              </div>

              <!-- Confirmar Contraseña -->
              <div class="space-y-2">
                <label class="text-standard block">Confirmar contraseña</label>
                <input 
                  v-model="form.password_confirmation" 
                  type="password" 
                  class="w-full text-neutral-500 text-sm font-light font-['Poppins'] leading-normal px-4 py-2 rounded-md border border-gray-300"
                  placeholder="Confirme su contraseña"
                  required
                >
              </div>
            </div>

             <!-- Sección de roles -->
             <div class="mt-6">
              <label class="text-standard block mb-2">Asignar rol:</label>
              <div class="flex flex-wrap gap-4">
                <div
                  v-for="rol in roles.filter(r => r.name === 'Admin' || r.name === 'Tuiner')"
                  :key="rol.id"
                  class="flex items-center space-x-2"
                >
                  <input
                    :id="'rol_' + rol.id"
                    type="checkbox"
                    :value="rol.id"
                    v-model="form.rol"
                    @change="handleRolChange"
                    class="w-4 h-4 text-pink-600 border-gray-300 rounded focus:ring-pink-500"
                  />
                  <label class="text-box" :for="'rol_' + rol.id">{{ rol.name }}</label>
                </div>
              </div>
              <!-- Alerta de roles corregida -->
              <div v-if="showRolAlert" class="required-alert">
                <div class="yellow-box">!</div>
                <span>Selecciona al menos un rol.</span>
              </div>
            </div>
            <!-- Botón de guardar -->
            <div class="mt-6 flex justify-end">
              <button 
                type="submit"
                class="custom-create-btn"
              >
                <span class="custom-create-btn-text">Guardar</span>
              </button>
            </div>
          </form>
        </div>
        <div class="p-4">
          <!-- Mensaje de éxito -->
          <div v-if="successMessage" class="user-alert">
            <div class="user-alert-content">
              <div class="user-alert-text">
                {{ successMessage }}
              </div>
            </div>
            <div class="w-4 h-4 relative"></div>
          </div>

          <!-- Mensaje de error -->
          <div v-if="errorMessage" class="user-alert-error">
           
              {{ errorMessage }}
          
          </div>
        </div>
        <head>
          <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
        </head>
      </div>
    </div>
  </div>
</template>

  <script>
  import axios from 'axios';
  import { ref, computed, onMounted } from "vue";
  import { useStore } from 'vuex';
  import 'vue-toastification/dist/index.css';
  import { useRouter } from "vue-router";
  export default {
    setup() {
      const store = useStore();
      const session = computed(() => store.getters.getUserSession);
      const roles = ref([]); 
      const successMessage = ref('');
      const errorMessage = ref(''); 
      const router = useRouter();
      const showRolAlert = ref(false); 
      
      const handleRolChange = () => {
        if (form.value.rol.length > 0) {
          showRolAlert.value = false;
        }
      };
      // Función para obtener los roles
      const fetchRoles = async () => {
        try {
          if (!session.value.token_api) {
            store.dispatch('clearUserSession');
            return;
          }
  
          const options = {
            headers: {
              'Authorization': `Bearer ${session.value.token_api}`
            }
          };
  
          const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/roles`, options);
          if (response.status === 200) {
            roles.value = response.data;
          } else if (response.status === 401) {
            store.dispatch('clearUserSession');
          }
        } catch (error) {
          console.error("Error al obtener los roles:", error);
          if (error.response && error.response.status === 401) {
            store.dispatch('clearUserSession');
          }
        }
      };
  
      // Llamar a fetchRoles cuando el componente se monte
      onMounted(() => {
        fetchRoles();
      });
  
      // Manejar el envío del formulario
      const submitForm = () => {
        const token = session.value.token_api;

        // Validar que se haya seleccionado al menos un rol
        if (form.value.rol.length === 0) {
          showRolAlert.value = true;
          return; // Solo mostrar la alerta visual, sin showToast
        }

        // Si hay roles seleccionados, ocultar la alerta
        showRolAlert.value = false;

        // Validar que exista un token
        if (!token) {
          console.error("No se ha encontrado el token de autenticación.");
          return;
        }

        // Enviar datos al servidor
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/broker/profile/create_account`, form.value, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then(response => {
          showToast('Usuario creado con éxito');
          console.log('Usuario creado con éxito', response.data);

          if (session.value.step < 3) {
            session.value.step = 1;
            router.push({ name: "usersList" });
          }
        })
        .catch(error => {
          console.error('Error al crear usuario', error);
          let errorMessage = 'Error al crear usuario';

          if (error.response?.data?.errors) {
            // Extraer solo los mensajes de error sin los campos
            const errorMessages = Object.values(error.response.data.errors)
              .map(errors => errors[0]); // Tomar solo el primer error de cada campo
            errorMessage = errorMessages.join('\n'); // Unir los mensajes de error
          }
          showToast(errorMessage, true);

          if (error.response?.status === 401) {
            console.error('No autorizado. Sesión cerrada.');
            store.dispatch('clearUserSession');
          }
        });
      };
        // Mostrar notificaciones de éxito o error
        const showToast = (message, isError = false) => {
          if (isError) {
            errorMessage.value = message;
            successMessage.value = ''; // Limpiar mensaje de éxito
          } else {
            successMessage.value = message;
            errorMessage.value = ''; // Limpiar mensaje de error
          }

          setTimeout(() => {
            if (isError) {
              errorMessage.value = '';
            } else {
              successMessage.value = '';
            }
          }, 3000);
        };

      const form = ref({
        email: '',
        name: '',
        last_name: '',
        last_second_name: '',
        password: '',
        password_confirmation: '',
        company_id: 1,
        rol: []
      });
      
      return {
        roles,
        fetchRoles,
        session,
        form,
        submitForm,
        errorMessage,
        showToast,
        showRolAlert,
        handleRolChange
      };
    }
  };
  </script>
  <style scoped>
    .mb-3 label {
      display: block;
      margin-bottom: 0.5rem;
    }

    .roles-container {
      display: flex;
      flex-wrap: wrap; /* Permite que los elementos se ajusten a la siguiente línea si es necesario */
      gap: 10px; /* Espacio entre los checkboxes */
    }

    .checkbox-checked {
      display: flex;
      align-items: center;
      gap: 5px; /* Espacio entre el checkbox y la etiqueta */
    }
    /* Estilos para el checkbox cuando está seleccionado */
    .form-check-input:checked {
      background-color: #FF4265;  /* Cambia el color de fondo */
      border-color: #FF4265;      /* Cambia el color del borde */
    }

    /* Estilo para checkbox seleccionado */
    input[type="checkbox"]:checked {
      @apply bg-pink-600 border-pink-600;
    }
    .required-alert {
    display: flex; /* Permite alinear elementos en línea (texto y cuadro) */
    align-items: center; /* Centra el contenido verticalmente */
    background-color: #fff; /* Fondo blanco */
    color: #333; /* Texto en gris oscuro */
    padding: 10px;
    border: 1px solid #ccc; /* Borde gris */
    border-radius: 5px; /* Esquinas redondeadas */
    margin-top: 5px;
    position: relative; /* Para el triángulo */
    max-width: 300px; /* Ajusta el tamaño máximo si lo necesitas */
    word-wrap: break-word; /* Evita que el texto se desborde */
  }

  .required-alert .yellow-box {
    display: flex; /* Para centrar el contenido del cuadro */
    justify-content: center; /* Centra el contenido horizontalmente */
    align-items: center; /* Centra el contenido verticalmente */
    width: 24px; /* Tamaño del cuadro amarillo */
    height: 24px;
    background-color: #e59035; /* Color amarillo */
    margin-right: 10px; /* Espaciado entre el cuadro y el texto */
    border: 1px solid #e59035; /* Borde amarillo más oscuro */
    border-radius: 4px; /* Esquinas redondeadas */
    color: #fff; /* Color blanco para el texto */
    font-weight: bold; /* Hace el signo más visible */
    font-size: 16px; /* Ajusta el tamaño del signo */
    line-height: 1; /* Asegura que no haya espacio adicional */
  }

  .required-alert::after {
    content: "";
    position: absolute;
    top: -10px; /* Coloca el pico hacia arriba */
    left: 20px; /* Coloca el pico a la izquierda, ajustado desde el borde */
    width: 0;
    height: 0;
    border-left: 10px solid transparent; /* Lado izquierdo del borde */
    border-right: 10px solid transparent; /* Lado derecho del borde */
    border-bottom: 10px solid #fff; /* El triángulo blanco */
    z-index: 1; /* Asegura que quede sobre el fondo */
  }

  .required-alert::before {
    content: "";
    position: absolute;
    top: -11px; /* Coloca el borde gris un poco más arriba */
    left: 19px; /* Ajusta para alinearlo con el triángulo blanco */
    width: 0;
    height: 0;
    border-left: 11px solid transparent; /* Lado izquierdo del borde gris */
    border-right: 11px solid transparent; /* Lado derecho del borde gris */
    border-bottom: 11px solid #ccc; /* El borde gris */
    z-index: 0; /* Asegura que quede detrás del triángulo blanco */
  }
  </style>